import { render, staticRenderFns } from "./input-color.vue?vue&type=template&id=7d74f249"
import script from "./input-color.vue?vue&type=script&lang=js"
export * from "./input-color.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports